var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none d-xl-block"},[(_vm.phone.value)?_c('section',{staticClass:"call-buton"},[_c('a',{staticClass:"cc-calto-action-ripple",attrs:{"href":'tel:'+ _vm.phone.value}},[_c('img',{attrs:{"src":require("../../../assets/icon/phone_ico.png"),"alt":""}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }